import { Helmet } from "react-helmet-async";
import { BashLogo, FaReact, PythonLogo, CLogo, CPPLogo, TensorFlowLogo, LinuxLogo, DebianLogo, FestoLogo, ARMLogo, TIlogo, AtmelLogo, ArduinoLogo, NodeJSLogo } from "./Icons";


function Skills() {
  return (
    <div className="min-h-[calc(100vh-160px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 flex flex-col items-center justify-center px-6 py-16">
      <Helmet>
        <title>Skills | Luis Torre</title>
        <meta name="description" content="Learn more about Luis Torre, a Computer Engineering graduate working in automation." />
      </Helmet>
      
      <h2 className="text-4xl font-bold text-white mb-4 relative inline-block">Skills
        <span className="absolute left-0 bottom-0 w-full h-1 bg-[#45577a] rounded-full"></span>
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl w-full text-center">
        {/* Programming Languages */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center gap-3 mb-4 text-4xl text-blue-400">
            <PythonLogo width={40} height={40}/>
            <CLogo width={40} height={40}/>
            <CPPLogo width={40} height={40}/>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">
            Programming Languages
          </h3>
          <p className="text-gray-300">Python, C, C++, Assembly</p>
        </div>

        {/* Linux */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center mb-4 text-4xl text-green-400">
            <LinuxLogo width={50} height={40}/>
            <DebianLogo width={50} height={40}/>
            <BashLogo width={40} height={40}/>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">Linux</h3>
          <p className="text-gray-300">Shell scripting, automation, system management</p>
        </div>

        {/* PLC / Automation */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center mb-4 text-4xl text-yellow-400">
            <FestoLogo width={100} height={40} />
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">
            PLC & Automation
          </h3>
          <p className="text-gray-300">
            PLC programming, industrial control systems, and electropneumatics
          </p>
        </div>

        {/* Microcontrollers */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center gap-3 mb-4 text-4xl">
            <ARMLogo width={50} height={40}/>
            <TIlogo width={40} height={40} />
            <AtmelLogo width={50} height={40} />
            <ArduinoLogo width={50} height={40}/>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">
            Microcontrollers
          </h3>
          <p className="text-gray-300">Embedded systems, RTOS, firmware development</p>
        </div>

        {/* Web Development */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center gap-3 mb-4 text-4xl text-cyan-400">
            <FaReact />
            <NodeJSLogo width={40} height={40}/>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">
            Web Development
          </h3>
          <p className="text-gray-300">React, Node.js, responsive UI design</p>
        </div>

        {/* AI / ML */}
        <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg transition-transform duration-200 hover:scale-[1.02]">
          <div className="flex justify-center mb-4 text-4xl text-orange-400">
            <TensorFlowLogo width={50} height={40}/>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">
            AI & Machine Learning
          </h3>
          <p className="text-gray-300">TensorFlow, model training, and deployment</p>
        </div>

      </div>
    </div>
  );
}

export default Skills;
